import { getEnvVariable } from '@appcharge/shared-ui';
import { useQuery } from '@tanstack/react-query';

import { ELocalStorageKeys, EQueryKeys } from '../constants/enums';
import useAxios from '../hooks/useAxios';
import { localStorageUtil } from '../utils/localStorageUtil';

import { EApiRoutes, fetchConfig, getApiRouteOrMock } from './api.utils';

const BASE_URL =
  localStorageUtil.getAny(ELocalStorageKeys.ENVIRONMENT) ||
  getEnvVariable('REACT_APP_API_BASE_URL');

const PAYOUT_SEARCH_MAX_LIMIT = 100;

export default function usePayouts(projects?: string) {
  const axios = useAxios();
  const payoutsRoute = EApiRoutes.PAYOUTS;

  const getPayouts = useQuery({
    ...fetchConfig.list,
    refetchInterval: 1000 * 15,
    refetchIntervalInBackground: false,
    retry: false,
    queryKey: [EQueryKeys.PAYOUTS],
    queryFn: async () => {
      const response = await axios.post(
        `${getApiRouteOrMock(payoutsRoute)}/search`,
        { page: 1, limit: PAYOUT_SEARCH_MAX_LIMIT },
        projects ? { 'x-publishers': projects } : undefined
      );
      return response.data.data;
    }
  });

  const getPayoutByCompanyDownload = (payoutId: string) =>
    axios
      .get(
        `${BASE_URL}${getApiRouteOrMock(
          EApiRoutes.PAYOUTS
        )}/${payoutId}/download`,
        undefined,
        projects ? { 'x-publishers': projects } : undefined
      )
      .then((response) => {
        const url = response?.downloadLink;
        window.open(url, '_blank');
      })
      .catch((error) => {
        console.error('Error downloading payout:', error);
      });

  return {
    getPayouts,
    getPayoutByCompanyDownload
  };
}
